import { HEADER, LOCATION, DESCRIPTION, ASSIGNMENT } from "./_common";

import { REPEATABLE, SCHEDULE } from "../widgets";

export default {
  fields: [
    HEADER,
    DESCRIPTION(),
    LOCATION(),
    ASSIGNMENT(),
    { type: REPEATABLE },
    { type: SCHEDULE },
  ],
  actions: [],
};
